import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,

  makeStyles, TextField,

  Tooltip
} from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Formik } from 'formik';
import ChipInput from 'material-ui-chip-input';
import { DropzoneArea } from 'material-ui-dropzone';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import RichText from 'src/components/RichText/RichText';
import CompanyService from 'src/services/company/company.service';
import ProductService from 'src/services/product/product.service';
import { renderFileList, renderFileListDataSheet } from 'src/views/shared/components/FileList';
import 'src/views/shared/css/common.scss';
import { customProductValidations } from '../../utils/utils';
import ErrorComponent from './../../components/ErrorComponent';
import { ProductInfo } from './product-model';
import PublishModal from './publishModal';

const useStyles = makeStyles(() => ({
  root: {},
  companyHeadings: {
    backgroundColor: '#4688f0', color: '#fff',
  },
  uploadedFileContainer: {
    height: '30px',
    margin: '45px 0 0',
    padding: '8px 433px 2px 8px',
    backgroundColor: '#4688f0',
    width: '100%'
  },
  uploadedFileText: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.14',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#ffffff',
  },
  publishButton: {

  }
}));

const ProductDetails = ({ handleProductSubmit, handleNext, handleSkip, handleBack, deleteDataSheet, isSubmitView, className, productState, setProductState, publishButton, step, deleteProductModal, ...rest }) => {
  const classes = useStyles();
  const companyService = new CompanyService();
  let file = []
  const [localFile, setLocalFile] = React.useState([]);
  const [product_id, setProductid] = React.useState('');
  const [companyName, setCompanyName] = React.useState();
  const companyId = localStorage.getItem('companyId')
  const [error_values, setErrorValues] = React.useState(null);
  const [publishModalOpen, setPublishModalOpen] = React.useState(false);
  const [stepButton, setStepButton] = React.useState();
  const [formValue, setFormValue] = React.useState();



  const getCompanyData = () => {
    companyService.getCompanyByUser(false).then(
      res => {
        if (res !== undefined && res) {
          if (res?.company?.companyName) {
            setCompanyName(res.company.companyName);
          }
        }
      }
    ).catch((err) => console.log(':: err', err))
  }

  useEffect(() => {
    getCompanyData()
  }, []);

  useEffect(() => {
    if (error_values !== null) {
      customProductValidations(productState).then((validation_response) => {
        setErrorValues(validation_response);
      });
    }
  }, [productState])

  /*useEffect(() => {
    /// alert(productState.productId)
   // setProductid(productState.productId);
   // setCompanyId(productState.companyId);
  }, [productState])*/

  const handleFilesChange = (files) => {
    if (productState.isPublished === 1) {
      return "";
    }
    console.log(files);
    let tempFile = [...localFile];
    if (files.length > 0) {
      for (var i = 0; i < files.length; i++) {
        const fileDate = {
          userName: localStorage.getItem('user'),
          userId: localStorage.getItem('userId'),
          companyName,
          companyId,
          createdAt: new Date(),
          name: files[i].name,
          location: URL.createObjectURL(files[i]),
          mimetype: '',
          file: files[i]
        }
        tempFile.push(fileDate)
      }
    }
    setLocalFile(tempFile)
    file = tempFile
  }

  const deleteLocalFile = (index) => {
    var tempFile = [...localFile];
    tempFile.splice(index, 1)
    setLocalFile(tempFile)
    file = tempFile
  }

  var type = '';

  const handleProductInfoChange = (richText) => {
    if (productState.isPublished === 1) {
      return
    }
    productState.productInfo = richText;
  }

  const productService = new ProductService();
  // const [productState, setProductState] = React.useState(productInfo);
  const [hasError, setHasError] = useState(false);

  const handleChangeKeywords = (keywords) => {
    productState.keywords = keywords;
    productState._id = productState.productId;
    setProductState(new ProductInfo(productState));
  }
  const handleChangeNotableCustomers = (notableCustomers) => {
    productState.notableCustomers = notableCustomers;
    productState._id = productState.productId;
    setProductState(new ProductInfo(productState));
  }

  const handleChangeTargetPersona = (targetPersona) => {
    productState.targetPersona = targetPersona;
    productState._id = productState.productId;
    setProductState(new ProductInfo(productState));
  }

  const handleChangeCompetitors = (competitors) => {
    productState.competitors = competitors;
    productState._id = productState.productId;
    setProductState(new ProductInfo(productState));
  }
  const handleChangeVideoUrls = (productSolVideoUrl) => {
    productState.productSolVideoUrl = productSolVideoUrl;
    productState._id = productState.productId;
    setProductState(new ProductInfo(productState));
  }

  const updateState = (event) => {
    setProductState({ ...productState, [event.target.name]: event.target.value });
  }
  // console.log(publishButton, "publishButton");
  // console.log(productState, "productState");


  return (
    <Formik
      enableReinitialize={true}
      initialValues={productState}
      validator={() => ({})}
      onSubmit={async (values) => {
        //alert(product_id)
        // console.log(stepButton, "stepButton")
        values.step = 1;
        values.file = localFile.map(datum => datum.file);
        //alert(productState.productId)
        values.productId = productState.productId;
        values.companyId = companyId
        console.log(values);
        var validation_response = await customProductValidations(values);
        setErrorValues(validation_response);
        console.log(validation_response)
        if (Object.keys(validation_response).length === 0) {
          setErrorValues(null);
          if (stepButton === "savePublish") {
            setFormValue(values)
            setPublishModalOpen(true)
          } else
            if (stepButton === "save") {
              handleProductSubmit(values);

            }
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values,
      }) => (
        <form className={'requestly-rfp-form company-information mb-5'}>
          <div className={classes.pageSize + ' company-info-div'}>
            <Card style={{ 'marginBottom': '50px' }}>
              <CardHeader
                title="Product Information"
                subheader="(Please provide information on this product. This will be seen by prospects and customers when they evaluate vendors.) "
                className={classes.companyHeadings + ' requestly-rfp-heading'}
              />
              <Divider />
              <CardContent>
                <Grid
                  container
                  spacing={3}
                >

                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <TextField
                      error={Boolean(touched.productName && errors.productName)}
                      fullWidth
                      helperText={touched.productName && errors.productName}
                      label="Product Name"
                      name="productName"
                      onBlur={updateState}
                      onChange={handleChange}
                      value={values.productName}
                      variant="outlined"
                      className="requestly-bg-gray requestly-h-40"
                      disabled={productState.isPublished === 1}
                    />

                    {
                      (error_values !== null && error_values.productName !== undefined) ? <ErrorComponent text={error_values.productName} /> : ''
                    }
                  </Grid>

                  <Grid item md={12} xs={12}>
                    <Typography style={{ "marginTop": "-25px", "color": "#547087", "fontSize": "16px" }}> Product Info </Typography>
                    <RichText
                      className="requestly-bg-gray"
                      value={productState.productInfo}
                      onTextChange={handleProductInfoChange}
                    />
                    {
                      (error_values !== null && error_values.productInfo !== undefined) ? <ErrorComponent text={error_values.productInfo} /> : ''
                    }
                  </Grid>


                  <Grid item md={12} xs={12}>
                    <Tooltip title="Enter a keyword or phrase, press enter after each one" arrow>
                      <ChipInput
                        error={Boolean(touched.keywords && errors.keywords)}
                        fullWidth
                        disabled={isSubmitView}
                        helperText={touched.keywords && errors.keywords}
                        label="Keywords"
                        defaultValue={productState.keywords}
                        onChange={(chip) => handleChangeKeywords(chip)}
                        variant="outlined"
                        className="requestly-bg-gray multiselect-textbox"
                        disabled={productState.isPublished === 1}
                      />

                    </Tooltip>
                    {
                      (error_values !== null && error_values.keywords !== undefined) ? <ErrorComponent text={error_values.keywords} /> : ''
                    }
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <Tooltip title="Enter a keyword or phrase, press enter after each one" arrow>
                      <ChipInput
                        error={Boolean(touched.notableCustomers && errors.notableCustomers)}
                        fullWidth
                        disabled={isSubmitView}
                        helperText={touched.notableCustomers && errors.notableCustomers}
                        label="Notable Customers"
                        defaultValue={values.notableCustomers}
                        onChange={(chip) => handleChangeNotableCustomers(chip)}
                        variant="outlined"
                        className="requestly-bg-gray multiselect-textbox"
                        disabled={productState.isPublished === 1}
                      />

                    </Tooltip>
                    {
                      (error_values !== null && error_values.notableCustomers !== undefined) ? <ErrorComponent text={error_values.notableCustomers} /> : ''
                    }
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <Tooltip title="Enter a keyword or phrase, press enter after each one" arrow>
                      <ChipInput
                        error={Boolean(touched.targetPersona && errors.targetPersona)}
                        fullWidth
                        disabled={isSubmitView}
                        helperText={touched.targetPersona && errors.targetPersona}
                        label="Target Persona"
                        defaultValue={values.targetPersona}
                        onChange={(chip) => handleChangeTargetPersona(chip)}
                        variant="outlined"
                        className="requestly-bg-gray multiselect-textbox"
                        disabled={productState.isPublished === 1}
                      />
                    </Tooltip>
                    {
                      (error_values !== null && error_values.targetPersona !== undefined) ? <ErrorComponent text={error_values.targetPersona} /> : ''
                    }
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <Tooltip title="Enter a keyword or phrase, press enter after each one" arrow>
                      <ChipInput
                        error={Boolean(touched.competitors && errors.competitors)}
                        fullWidth
                        disabled={isSubmitView}
                        helperText={touched.competitors && errors.competitors}
                        label="Competitors"
                        defaultValue={values.competitors}
                        onChange={(chip) => handleChangeCompetitors(chip)}
                        variant="outlined"
                        className="requestly-bg-gray multiselect-textbox"
                        disabled={productState.isPublished === 1}
                      />
                    </Tooltip>
                    {
                      (error_values !== null && error_values.competitors !== undefined) ? <ErrorComponent text={error_values.competitors} /> : ''
                    }
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <Tooltip title="Enter a keyword or phrase, press enter after each one" arrow>
                      <ChipInput
                        fullWidth
                        disabled={isSubmitView}
                        helperText={touched.productSolVideoUrl && errors.productSolVideoUrl}
                        label="Product solution video url"
                        defaultValue={values.productSolVideoUrl}
                        onChange={(chip) => handleChangeVideoUrls(chip)}
                        variant="outlined"
                        className="requestly-bg-gray multiselect-textbox"
                        disabled={productState.isPublished === 1}
                      />
                    </Tooltip>

                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      helperText={touched.productLaunchDate && errors.productLaunchDate}
                      label="Product Launch Date"
                      name="productLaunchDate"
                      type="date"
                      onBlur={updateState}
                      onChange={handleChange}
                      value={values.productLaunchDate}
                      variant="outlined"
                      className="requestly-bg-gray requestly-h-40"
                      disabled={productState.isPublished === 1}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {
                      (error_values !== null && error_values.productLaunchDate !== undefined) ? <ErrorComponent text={error_values.productLaunchDate} /> : ''
                    }
                  </Grid>
                </Grid>
              </CardContent>

              <Accordion defaultExpanded={true} className="requestly-fin-info-tab">
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel-upload-content"
                  id="panel-upload"
                  className="requestly-tab-height"
                >
                  <Typography className={classes.heading}>Upload Datasheets</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <CardContent>
                      <Grid className={classes.listChecks} container spacing={0}>
                        <Grid md={12} sm={12} xs={12}>

                          <Grid item md={12} xs={12}>

                            <DropzoneArea
                              dropzoneText={'Drag and drop a file here or click  Supported Formats : ( .doc, .docx, .xls, .xlsx, .csv, .tsv, .ppt, .pptx, .pages, .odt, .rtf, .pdf, .jpg, .png, .jpeg )'}
                              maxFileSize="104857600"
                              acceptedFiles={['.doc', '.docx', '.xls', '.xlsx', '.csv', '.tsv', '.ppt', '.pptx', '.pages', '.odt', '.rtf', '.pdf', '.jpg', '.png', '.jpeg']}
                              onChange={handleFilesChange}
                              showFileNames={true}
                              showPreviewsInDropzone={false}
                              filesLimit={20}
                              showAlerts={productState.isPublished === 1 ? false : true}
                            />
                          </Grid>
                          {((localFile?.length) || (values.dataSheets_docs && values.dataSheets_docs.length > 0))
                            ?
                            <Grid item md={12} xs={12}>
                              <Box className={classes.uploadedFileContainer}>
                                <Typography className={classes.uploadedFileText}>
                                  Uploaded files
                                </Typography>
                              </Box>
                            </Grid>
                            :
                            ''}

                          {localFile?.length ? (
                            <Grid item md={12} xs={12} style={{ marginTop: '15px' }}>
                              {renderFileList(localFile, classes.table, true, deleteLocalFile, productState.isPublished)}
                            </Grid>
                          ) : null}

                          {values.dataSheets_docs && values.dataSheets_docs.length > 0
                            ? <Grid item md={12} xs={12} style={{ marginTop: '15px' }}>{renderFileListDataSheet(values.dataSheets_docs, classes.table, false, deleteDataSheet, productState.productId, productState.isPublished)}</Grid>
                            : null}

                        </Grid>
                      </Grid>



                    </CardContent >
                  </Typography >
                </AccordionDetails >
              </Accordion >

              <Accordion defaultExpanded={true} className="requestly-fin-info-tab">
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel-pricing-content"
                  id="panelpPricing"
                  className="requestly-tab-height"
                >
                  <Typography className={classes.heading}>Pricing</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <CardContent>
                      <Grid
                        container
                        spacing={3}
                      >
                        <Grid
                          item
                          md={12}
                          xs={12}
                        >
                          <TextField
                            fullWidth
                            helperText={touched.pricingProductName && errors.pricingProductName}
                            label="Product Name"
                            name="pricingProductName"
                            onChange={handleChange}
                            onBlur={updateState}
                            value={values.pricingProductName}
                            variant="outlined"
                            className="requestly-bg-gray requestly-h-40"
                            disabled={productState.isPublished === 1}
                          />
                        </Grid>
                        <Grid
                          item
                          md={12}
                          xs={12}
                        >
                          <TextField
                            fullWidth
                            helperText={touched.unit && errors.unit}
                            label="Unit"
                            name="unit"
                            onBlur={updateState}
                            onChange={handleChange}
                            value={values.unit}
                            variant="outlined"
                            className="requestly-bg-gray requestly-h-40"
                            disabled={productState.isPublished === 1}
                          />
                        </Grid>

                      </Grid>
                    </CardContent>
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Divider />

              <div style={{ display: (publishModalOpen || deleteProductModal) && "none" }}>
                <div class="footer-btn-fixed">
                  <footer class="page-footer green">
                    <Grid item container>
                      <Grid container spacing={2} justify="center">
                        <Grid item md={3} sm={3} xs={3}>
                          <Button
                            color="primary"
                            variant="contained"
                            onClick={() => {
                              setStepButton("save");
                              handleSubmit(values)
                            }}
                            disabled={productState.isPublished === 1}
                          >
                            Save
                          </Button>
                        </Grid>
                        <Grid item md={3} sm={3} xs={3}>
                          <Button
                            color="primary"
                            variant="contained"
                            // onClick={() => { handleSubmit(values) }}
                            onClick={() => {
                              setStepButton("savePublish");
                              handleSubmit(values)
                            }}
                            disabled={productState.isPublished === 1}
                            style={{ width: "62%" }}
                          >
                            Save & Publish
                          </Button>
                        </Grid>
                        {productState.isPublished === 1 && <Grid item md={3} sm={3} xs={3} className={classes.publishButton}>
                          <Button
                            color="primary"
                            variant="contained"
                            onClick={() => { setPublishModalOpen(true) }}
                          >
                            UnPublish
                          </Button>
                        </Grid>}

                      </Grid>
                    </Grid>
                  </footer>
                </div>
              </div>
            </Card >
          </div >
          {publishModalOpen && (
            <PublishModal
              publishModalOpen={publishModalOpen}
              product={productState.productId}
              isPublished={productState.isPublished}
              formValue={formValue}

              closeEditModal={() => {
                setPublishModalOpen(false)
              }
              }
            />
          )}
        </form >

      )}

    </Formik >

  );
};

ProductDetails.propTypes = {
  className: PropTypes.string
};

export default ProductDetails;
